import React from 'react'

const FooterLite = ({
  editionUserGeo
}) => {

  const internetBasedAds = (editionUserGeo === 'us') ? 'http://preferences-mgr.truste.com/?type=espn&affiliateId=148' : 'http://preferences-mgr.truste.com/?pid=disney01&aid=espnemea01&type=espnemea'
  const currentYear = new Date().getFullYear()

  return (
    <div>
      <div className="cricinfo__footer">
          <div className="cricinfo__footer__detail">
            &copy; {currentYear} ESPN Sports Media Ltd. 
            <a href="http://disneytermsofuse.com/" target="_blank">Terms of Use</a>,&nbsp;
            <a href="http://disneyprivacycenter.com/" target="_blank">Privacy Policy</a>,&nbsp;
            <a href="https://disneyprivacycenter.com/cookies-policy-translations/cookies-policy/" target="_blank">Cookie Policy</a>,&nbsp;
            <a href="http://www.nielsen.com/digitalprivacy" target="_blank">About Nielsen Measurement</a> and&nbsp;
            <a href={internetBasedAds || '#'} target="_blank">Interest-Based Ads</a> are applicable to you. All rights reserved.
          </div>
          <div className="cricinfo__footer__actions">
            <a href="#" target="_blank" className="cricinfo__type__link">More from ESPN</a>
            <ul className="cricinfo__footer__link__list">
                <li className="cricinfo__footer__link__list__item">
                  <a href="#" target="_blank" className="cricinfo__type__link">ESPN</a>&nbsp;
                </li>
                <li className="cricinfo__footer__link__list__item">
                  <a href="#" target="_blank" className="cricinfo__type__link">The Cricket Monthly</a>&nbsp;
                </li>
                <li className="cricinfo__footer__link__list__item">
                  <a href="#" target="_blank" className="cricinfo__type__link">FireThirtyEight</a>
                </li>
            </ul>
          </div>
        </div>
    </div>
  )
}

export default FooterLite



// WEBPACK FOOTER //
// ../app/components/common/lite/FooterLite.jsx